import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';

// ----------------------------------------------------------------------
const base_url = '/v1/employeeareas';

const initialState = {
  isLoading: false,
  error: null,
  employeeareas: [],
  employeearea: null,
};

const slice = createSlice({
  name: 'conf_ea',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET ALL
    getConfEa(state, action) {
      state.isLoading = false;
      state.employeeareas = action.payload;
    },

    // GET ONE
    getOneConfEa(state, action) {
      state.isLoading = false;
      state.employeearea = action.payload;
    },

    // CREATE
    createConfEa(state, action) {
      const newdata = action.payload;
      state.isLoading = false;
      state.employeeareas = [...state.employeeareas, newdata];
    },

    // UPDATE
    updateConfEa(state, action) {
      state.isLoading = false;
    },
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function get() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(base_url);
      dispatch(slice.actions.getConfEa(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getById(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${base_url}/${id}/employeearea`);
      dispatch(slice.actions.getOneConfEa(response.data.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getByDescription(description) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${base_url}/${description}/employeearea`);
      dispatch(slice.actions.getOneConfEa(response.data.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function create(newData) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`${base_url}`, newData);
      dispatch(slice.actions.createConfEa(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

// ----------------------------------------------------------------------

export function update(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.put(`${base_url}`, data);
      dispatch(slice.actions.updateConfEa(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function deleteById(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`${base_url}?id=${id}`);
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
